import React, { Component } from "react";
import ChaptersPanel from "./ChaptersPanel";
import ChaptersPanelByType from "./ChaptersPanelByType";

export default class ActiveChaptersPanel extends Component {
  render() {
    const {
      project,
      projectType,
      chapters = [],
      ...rest
    } = this.props;

    if (!project) return null;

    if (project.project_type_key && projectType) {
      return (
        <ChaptersPanelByType
          {...rest}
          project={project}
          chapters={chapters}
          projectType={projectType}
        />
      );
    }

    return <ChaptersPanel {...rest} project={project} chapters={chapters} />;
  }
}
